import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ArrowRight } from "lucide-react";

export const WelcomeModal = () => {
  const [open, setOpen] = useState(true);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="welcome-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="fixed inset-0 z-[60] grid place-items-center px-5"
        >
          {/* dim backdrop */}
          <div
            className="absolute inset-0 bg-[#0d1526]/80 backdrop-blur-sm"
            onClick={() => setOpen(false)}
          />

          <motion.div
            initial={{ y: 30, scale: 0.96, opacity: 0 }}
            animate={{ y: 0, scale: 1, opacity: 1 }}
            exit={{ y: 20, scale: 0.98, opacity: 0 }}
            transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1], delay: 0.05 }}
            className="relative w-full max-w-2xl rounded-3xl border border-[#D7E85C] bg-[#16294B] p-8 md:p-12 shadow-[0_40px_120px_-40px_rgba(0,0,0,0.8)]"
          >
            <button
              data-testid="welcome-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
              className="absolute top-5 right-5 grid place-items-center h-10 w-10 rounded-full bg-white/10 text-[#EBE6E0] hover:bg-[#D7E85C] hover:text-[#1F3864] transition-colors"
            >
              <X size={18} />
            </button>

            <span className="text-xs font-bold uppercase tracking-[0.3em] text-[#D7E85C]">
              #fromFilipinostotheWorld
            </span>
            <h2 className="mt-5 font-display font-black uppercase tracking-tight leading-[0.95] text-3xl md:text-5xl text-[#EBE6E0]">
              <span className="block font-bold text-lg md:text-2xl tracking-normal text-[#D7E85C]">BETA VERSION!</span>
              A new Rada Collab experience is being built. See our latest campaign <ArrowRight className="inline-block -mt-1" size={34} aria-hidden />
            </h2>
            <p className="mt-6 text-[#FFFFFF]/70 text-base md:text-lg leading-relaxed">
              Please note: Some details are placeholders, and may be updated, including pricing and inclusions.
            </p>
            <p className="mt-3 text-[#D7E85C] text-sm md:text-base font-bold">
              For more information, email us at hello@radacollab.com.
            </p>

            <button
              data-testid="welcome-enter"
              onClick={() => setOpen(false)}
              className="mt-8 inline-flex items-center bg-[#D7E85C] text-[#1F3864] px-7 py-3 rounded-full font-bold uppercase text-sm tracking-wide hover:bg-[#EBE6E0] active:scale-95 transition-[background,transform] duration-200"
            >
              Enter the site
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
